import React from 'react'
import { connect } from 'react-redux'

import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { TidewaysContext } from './app/context'
import { Entity } from './app/entity'
import BoxBody from './helper/boxBody'
import MyProfiles from './monitor/my-profiles'
import { ApplicationState } from './redux/ApplicationState'
import Router from './router'

interface OwnProps {
    tidewaysContext: TidewaysContext
    router: Router
}

type Props = OwnProps & Entity<{ token: string; tidewaysContext: TidewaysContext } | null> & RouteComponentProps

export interface TriggerTraceState {
    token: string
    copied: boolean
}

export class TriggerTrace extends React.Component<Props, TriggerTraceState> {
    public static defaultProps = {
        loading: false,
    }

    public state: TriggerTraceState = {
        token: '',
        copied: false,
    }

    public reload = () => {
        jQuery.ajax({
            url: this.props.router.path('XhprofOrganizationBundle.Application.token'),
            success: data => {
                this.setState({ token: data.token, copied: false })
            },
        })
    }

    public copyToClipboard = () => {
        if (this.clipboardApiAvailable()) {
            navigator.clipboard.writeText(this.state.token)
            this.setState({ copied: true })
        }
    }

    public render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="box box-default">
                        <div className="box-header">
                            <h3 className="box-title">Manually Trigger Traces</h3>
                        </div>
                        <BoxBody {...this.props}>
                            <h4>1. Using Commandline Client</h4>

                            <p>
                                You can trigger traces for PHP scripts in your application using the{' '}
                                <a
                                    href="https://support.tideways.com/documentation/reference/commandline-interface/overview.html?utm_medium=app&utm_source=trigger-trace&utm_campaign=commandline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    commandline interface
                                </a>
                                .
                            </p>

                            <pre>
                                <code>
                                    $ tideways run {this.props.tidewaysContext.organization.name}/
                                    {this.props.tidewaysContext.application.name} php script.php
                                </code>
                            </pre>

                            <p>If you want to trigger a trace for a website you can curl it through cURL:</p>

                            <pre>
                                <code>
                                    $ tideways run {this.props.tidewaysContext.organization.name}/
                                    {this.props.tidewaysContext.application.name} curl https://your-site.local/script.php
                                </code>
                            </pre>

                            <p>
                                Use the &quot;Copy as cURL&quot; feature in Chrome Developer Tools to get all the necessary headers and
                                cookies for pages behind logins.
                            </p>

                            <p className={'text-center'}>
                                <img src="https://tideways.com/wp-content/uploads/import/docs/cli_copyascurl.png" />
                            </p>

                            <h4>2. Using Chrome Extension</h4>

                            <p>
                                You can trigger traces using the Chrome Extension. After{' '}
                                <a
                                    href="https://support.tideways.com/documentation/reference/browser-extension/chrome-extension.html?utm_medium=app&utm_source=trigger-trace&utm_campaign=chrome-extension"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    installation
                                </a>
                                , click the Tideways Profiler button in the toolbar to start tracing.
                            </p>

                            <div>
                                <h4>3. Using GET-Parameters</h4>

                                <p>
                                    Generate a token to append to a request that you want to trigger a profile for. Be careful to correctly
                                    use question mark (?) or ampersand (&amp;).
                                </p>

                                <div className="input-group">
                                    <div className="input-group-btn">
                                        <a className="btn btn-primary" id={'detailed'} onClick={this.reload}>
                                            Generate Token
                                        </a>
                                    </div>
                                    {this.state.token ? (
                                        <div className="input-group-btn">
                                            <a className="btn btn-default" onClick={this.copyToClipboard}>
                                                {this.state.copied ? 'Copied!' : 'Copy'}
                                            </a>
                                        </div>
                                    ) : null}
                                    <input
                                        readOnly
                                        type="text"
                                        id="triggerToken"
                                        className="form-control"
                                        value={
                                            this.state.token
                                                ? this.state.token
                                                : 'Click Generate Token for a query string to attach to any URL of this project'
                                        }
                                        onClick={() => {
                                            jQuery('#triggerToken').select()
                                        }}
                                    />
                                </div>
                            </div>
                        </BoxBody>
                    </div>
                </div>
                <div className="col-md-12 callgraph-traces">
                    <MyProfiles showTriggerButton={false} />
                </div>
            </div>
        )
    }

    private clipboardApiAvailable = () => {
        return navigator.clipboard && typeof navigator.clipboard.writeText !== 'undefined'
    }
}

export default withRouter(
    connect((globalState: ApplicationState, props) => {
        return {
            tidewaysContext: globalState.tidewaysContext,
            router: globalState.tidewaysContext.router,
        }
    })(TriggerTrace),
)
